var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ViewFeedItem',{staticClass:"view-feed-fact",scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('h3',{staticClass:"push-bottom"},[_vm._v("Did you know...")]),_c('p',{key:_vm.factModel.uniqueKey,domProps:{"innerHTML":_vm._s(_vm.factModel.getFact())}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }